import { faBuildingWheat, faHouse, faLeaf } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Typography } from '@mui/material';
import { useRecordContext, useTranslate } from 'react-admin';
import globalUseStyles from '../../../styles/globalCustomStyles';
import ChartLoading from '../../aegeon/charts/ChartLoading';
import ChartNoData from '../../aegeon/charts/ChartNoData';
import { getColors, getNote, getObjectiveText, getObjectiveYear, getWorstCrremValue, getWorstYearType } from '../../aegeon/compute_performances';
import { useQueryContext } from '../../aegeon/query/useQueryContext';
import useQueryProvider from '../../aegeon/query/useQueryProvider';

const SiteEnergeticPerformanceCard = (props) => {
  const globalClasses = globalUseStyles();
  const t = useTranslate();
  const { data, isLoading } = useQueryContext(props);
  const record = useRecordContext(props);
  const siteId = record?.id;

  let { data: dpeTable, isLoading: isLoadingDpeTable } = useQueryProvider(
    'sites',
    {
      query_name: "getSiteDpeTable",
      id: siteId,
    }
  );

  let { data: crremObjectivesTable, isLoading: isLoadingCrrem } = useQueryProvider(
    'sites',
    {
      query_name: "getSiteCrremObjectivesTable",
      id: siteId,
    }
  );

  const deet_perf = data?.performances?.find((p) => p.type === "DEET_PCI");
  const deet_value = deet_perf?.value ? Math.round(deet_perf.value * 100) / 100 : null;

  const dpe_energy_note = getNote(data?.performances?.find((p) => p.type === "DPE_ENEP")?.value, dpeTable, "DPE_ENEP");
  const dpe_ghg_note = getNote(data?.performances?.find((p) => p.type === "DPE_GHG")?.value, dpeTable, "DPE_GHG");
  const dpe_max_type = dpe_energy_note >= dpe_ghg_note ? "DPE_ENEP" : "DPE_GHG";
  const dpe_perf = data?.performances?.find((p) => p.type === dpe_max_type);
  const dpe_note = getNote(dpe_perf?.value, dpeTable, dpe_max_type);
  const dpe_value = dpe_perf?.value ? Math.round(dpe_perf.value * 100) / 100 + " " + dpe_perf.unit : null;
  const dpe_note_color = getColors(dpe_max_type)[dpe_note] || "#6c74d8";

  const energy_year = getObjectiveYear("CRREM_PCS", data, crremObjectivesTable);
  const ghg_year = getObjectiveYear("CRREM_GHG", data, crremObjectivesTable);
  const worst_crrem_type = getWorstYearType(energy_year, ghg_year);

  const worst_year = worst_crrem_type === "CRREM_PCS" ? energy_year : ghg_year;
  const worst_crrem_unit = data?.performances?.find((p) => p.type === worst_crrem_type)?.unit;
  const worst_crrem_value = getWorstCrremValue(data, worst_crrem_type, worst_year) + " " + worst_crrem_unit;
  const crrem_text = getObjectiveText(worst_year);

  const crrem_classname = worst_crrem_type === "CRREM_PCS" ? globalClasses.crrem_energy : globalClasses.crrem_ghg;

  return (
    <>
      {isLoading ?
        <ChartLoading />
        : !data || deet_perf?.value === null ?
          <ChartNoData />
          :
          <div className={globalClasses.composition}>
            <Box className={globalClasses.compositionBox} >
              <div className={globalClasses.compositionNumber}>
                <FontAwesomeIcon icon={faLeaf} className={globalClasses.deet} />
                <Typography variant="h3" component="div" className={globalClasses.compositionText + " " + globalClasses.deet}>
                  DEET
                </Typography>
              </div>
              <div className={globalClasses.compositionNumber}>
                <Typography variant="h4" component="div" className={globalClasses.deet}>
                  {deet_value}
                </Typography>
              </div>
              <Typography variant="h9" component="div" className={globalClasses.compositionText}>
                {deet_value ? deet_perf?.unit : ""}
              </Typography>
            </Box>
            <Box className={globalClasses.compositionBox} >
              <div className={globalClasses.compositionNumber}>
                <FontAwesomeIcon icon={faHouse} color={dpe_note_color} />
                <Typography variant="h3" component="div" color={dpe_note_color} className={globalClasses.compositionText}>
                  DPE
                </Typography>
              </div>
              <div className={globalClasses.compositionNumber}>
                <Typography variant="h4" component="div" color={dpe_note_color} className={globalClasses.compositionText}>
                  {dpe_note}
                </Typography>
              </div>
              <Typography variant="h9" component="div" className={globalClasses.compositionText}>
                {dpe_value}
              </Typography>
            </Box>
            <Box className={globalClasses.compositionBox} >
              <div className={globalClasses.compositionNumber}>
                <FontAwesomeIcon icon={faBuildingWheat} className={crrem_classname} />
                <Typography variant="h3" component="div" className={globalClasses.compositionText + " " + crrem_classname}>
                  CRREM
                </Typography>
              </div>
              <div className={globalClasses.compositionNumber}>
                <Typography variant="h4" component="div" className={globalClasses.compositionText + " " + crrem_classname}>
                  {crrem_text}
                </Typography>
              </div>
              <Typography variant="h9" component="div" className={globalClasses.compositionText}>
                {worst_crrem_value}
              </Typography>
            </Box>
          </div>
      }
    </>
  )
}

export default SiteEnergeticPerformanceCard